var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_7305_24292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7305_24292",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7305_24292",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7305_24292",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADP0lEQVR4nO2cwWoTQRjHf7sJ3UDAQgVNQwlLu3rJ0SfwJD0ItTcfoCfxATx48uArSF9BqYqH0oOIryGhlN6kqFhaTHCT9VAXQjDbNJndman/36VQhv2++f+zM22+bwaEEEIIIYQQQgghhBBCCCGEEFekFcfx6trGbpIkke1cFiVJkmh1bWO3FcdxGc8PTT+w3V7vBGntI7Bz3s/ex3HcMB2jKrrd7tLZYPQa2AnS2ufbnbvrpmMEJh/Wbq93sjD4BIwnehDVh1tHR0d9k7HKptvtLn07/fUmyIKHY78+HoW1+1+PvxyaimPMgCni53hlwhTxc4yaYGwJysLgOf8WH+DBIK3t+bAnJEkSff/ZfzdFfIBOOBo+MxXPmAEry40nWZB9KBiy6fqeMLbmbxYMO4jqw6emYhrdAy55dXOcXI5s5W7UAPDTBJs5GzcA/DLBdq6lGAD2JzYLLuRYmgHgxgSn4UpupRoA7kzU1ZxKNwDcmrBLuUBFBoAbE3chh0kqMwDsCuCi+FCxAWBHCFfFBwsGQLWCuCw+WDIAqhHGdfHBogFQrkA+iA+WDYByhPJFfHDAADArmE/igyMGgBnhfBMfHDIAFhPQR/HBMQNgPiF9FR8cNACuJmiz2Rz5Kj44agBcFMfP+9lbiuuz+39/Fo5pNoJHvV5vYC47czhrAMz8JhTh7Cc/x2kDYCETnBcfPDAA5jLBC/HBEwNg5j0BHF/zJzHenFsWURRlWZClMwwN0zT15oPlRaJagiyiTdgi+jPUIv/LP2JObsJX6FLeXllubPncle3cG6Av4yyir6MtooKMRVSStIiK8hZRW4oasxaOsShqTTQYax7UnFtSzFlRe3oFsYvQAY2Kc5hER5Qs5gI6pGc9Jx1Tva7HVF2ZYBEu5KirCq7bVQW2JzQP1+ayDh/Fz/H+uhqfxc+xMYeaiYcA1KMbrwKCxwVD9puNYOvw8NDJ4jjAycnJsHXr5t7vlHvAnSnDkuEobJ2d/iiqQ8+MsaJ8MMpeANMusjuI6sNtVzsTxun1eoNLCv3Ho7D20lQ8XVs5Be+urcyZMMFL8XMmTDAufmno6mIhhBBCCCGEEEIIIYQQQgghxAV/AIvGVeWGXu8lAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGray);
export default __webpack_public_path__ + "static/media/icon-close-gray.16db9380a98fad0b3e9e3d3e31dea5f1.svg";
export { ForwardRef as ReactComponent };